import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import {
  renderTextField,
  requiredValidator,
  renderNumberField,
  renderDatePicker
} from 'utils/formHelper';
import {
  createInvestment,
  updateInvestment,
} from 'actions/investments';
import date from 'utils/date';
import moment from 'moment';

const styles = {};

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false }
  };

  submit = (attrs) => {
    const { dispatch, investorId, investment, mode } = this.props;
    let action;
    if (mode === 'create') {
      action = createInvestment(attrs);
    } else {
      action = updateInvestment({ id: investment.id, ...attrs });
    }
    return dispatch(action)
      .then(this.handleClose)
      .catch(this.handleSubmitFailure);
  }

  handleSubmitFailure = (error) => {
    if (error && error.response) {
      throw new SubmissionError(error.response);
    }
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  renderForm = () => {
    return (
      <div>
        <div className='form-row' >
          <Field
            select
            name='product'
            component={renderTextField}
            label='Loan product'
            validate={requiredValidator}
          >
            {
              [
                'Easy Loan',
                'Credit Loan',
                'Full Loan'
              ].map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))
            }
          </Field>
        </div>
        <div className='form-row' >
          <Field
            name='amount'
            component={renderTextField}
            label='Amount'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='interestRate'
            component={renderTextField}
            label='Interest rate'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='startAt'
            component={renderDatePicker}
            label='Start date'
            validate={requiredValidator}
          />
        </div>
        <div className='form-row' >
          <Field
            name='endAt'
            component={renderDatePicker}
            label='End date'
            validate={requiredValidator}
          />
        </div>
      </div>
    );
  }

  title = () => {
    const { mode } = this.props;
    if (mode === 'create') {
      return 'Create Investment';
    } else {
      return 'Update Investment';
    }
  }

  render = () => {
    const { open } = this.state;
    const {
      handleSubmit,
      buttonLabel,
      buttonStyles,
      reset,
      investment
    } = this.props;

    return (
      <div>
        <Button
          className={buttonStyles}
          color='primary'
          onClick={() => this.setState({ open: true })}
        >
          {buttonLabel}
        </Button>
        <Dialog
          open={open}
          onEnter={reset}
          onClose={this.handleClose}
        >
          <form onSubmit={ handleSubmit(this.submit) }>
            <DialogTitle>{this.title()}</DialogTitle>
            <DialogContent style={{ width: 500 }}>
              {this.renderForm()}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose}>CANCEL</Button>
              <Button type='submit' color='primary'>SUBMIT</Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const now = moment().format('DD/MM/YYYY')
  let initialValues = {
    investorId: ownProps.investorId,
    startAt: now
  };
  if (ownProps.investment) {
    initialValues = { ...initialValues, ...ownProps.investment }
  }
  return { initialValues };
};

const reduxed = reduxForm({ enableReinitialize: true })(Form);
const connected = connect(mapStateToProps)(reduxed);
export default withStyles(styles)(connected);



// WEBPACK FOOTER //
// ./src/components/Investors/InvestmentForm.js